// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { castToString } from 'helpers/reduxFormFunctions'
import scrubIgnoredPathsForForm from '../scrubIgnoredPathsForForm'

const formatFilterForForm = v => {
  //  keep track of this since we'll need it to update db for this filter.
  const {
    afsFilterId,
    ignoredContacts,
    ignoredSegmentStatuses,
  } = v

  // environmentPathMarginDb - Ignore Margin From Me
  const environmentPathMarginDb = castToString(v.environmentPathMarginDb)

  // proposedPathMarginDb - Ignore Margin Into Me
  const proposedPathMarginDb = castToString(v.proposedPathMarginDb)

  // buckDistanceKm - Buck Distance
  const buckDistanceKm = castToString(v.buckDistanceKm)

  // ignoredTerrCases - Ignore Case #
  const ignoredTerrCases = castToString(v.ignoredTerrCases)

  // ignorePreviousPathFlag - Ignore All Previous Path Links
  const ignorePreviousPathFlag = castToString(v.ignorePreviousPathFlag)

  // secondaryFlag - Ignore Secondary License Basis
  const secondaryFlag = castToString(v.secondaryFlag)

  // - Standard 10 - //
  // s10AccpFlag - Type A: ACCP
  const s10AccpFlag = castToString(v.s10AccpFlag)
  // s10AcapFlag - Type B: ACAP
  const s10AcapFlag = castToString(v.s10AcapFlag)
  // s10DeltaFFlag - Δf > 2 Bandwidths
  const s10DeltaFFlag = castToString(v.s10DeltaFFlag)

  // afsProtectionType - Ignore Paths based on Protected Status
  const afsProtectionTypeId = castToString(v.afsProtectionTypeId)

  // the giant ignored paths table. you can't miss it.
  const ignoredPaths = scrubIgnoredPathsForForm(v.ignoredPaths)

  return {
    afsFilterId,
    afsProtectionTypeId,
    buckDistanceKm,
    environmentPathMarginDb,
    ignoredContacts,
    ignoredSegmentStatuses,
    ignoredPaths,
    ignoredTerrCases,
    ignorePreviousPathFlag,
    proposedPathMarginDb,
    s10AcapFlag,
    s10AccpFlag,
    s10DeltaFFlag,
    secondaryFlag,
  }
}

export default formatFilterForForm
